import { useI18n } from "./i18n";

export type ReclaimNotice = { sandboxID: string; state: string; errorCode: string };
export function RuntimeReclaimNotice({ result }: { result: ReclaimNotice }) {
  const { t } = useI18n();
  const failed = result.state === "failed";
  const text = result.state === "succeeded"
    ? t(`运行实例 ${result.sandboxID} 已确认回收。`, `Runtime ${result.sandboxID} reclamation was confirmed.`)
    : result.state === "pending"
      ? t("回收仍在进行，正在等待删除确认。可在操作记录中查看。", "Reclamation is pending deletion confirmation. Check the operation history.")
      : t("回收未完成，请重新检查实例的保留状态和任务占用。", "Reclamation did not complete. Recheck retention and task bindings.");
  return <div className={failed ? "global-error administrator-message" : "administrator-message"} role={failed ? "alert" : "status"}>
    {text}{failed && result.errorCode ? ` (${result.errorCode})` : ""}
  </div>;
}
